import {
  MultiPolygonGeoJsonFeature,
  multiPolygonGeoJsonFeatureSchema,
} from './PolygonGeoJsonFeature';
import { PlaceType } from './PlaceType';
import z from 'zod';
import { BoundedRectangle } from './BoundedRectangle';

export const geographicAreaSchema = z.object({
  name: z.string(),
  contextArea: z.string(),
  type: z.nativeEnum(PlaceType),
  boundingBox: z.array(z.array(z.number())),
  geoJsonFeature: multiPolygonGeoJsonFeatureSchema.optional(),
  areaId: z.string().optional(),
});

// TODO: would be cool to use the zod inferred type but it doesn't work well because it sets everything to optional - see: https://github.com/colinhacks/zod/issues/121#issuecomment-675671241
// export type GeographicArea = z.infer<typeof geographicAreaSchema>;

export type GeographicArea = {
  name: string;
  contextArea: string;
  type: PlaceType;
  boundingBox: BoundedRectangle;
  geoJsonFeature?: MultiPolygonGeoJsonFeature; // TODO: should this eventually not be optional?
  areaId?: string;
};
